import type { ReactNode } from 'react';
import { cx, SURFACE_GRAIN } from '@wapharma/design-system';
import { resolveDeployOrgBrand } from '../../lib/deployOrgBrand';
import styles from './auth-layout.module.css';

type AdminAuthLayoutProps = {
  children: ReactNode;
  brandTitle?: string;
  brandBody: string;
};

export function AdminAuthLayout({
  children,
  brandTitle,
  brandBody,
}: AdminAuthLayoutProps) {
  const brand = resolveDeployOrgBrand();
  const title = brandTitle ?? brand.defaultBrandTitle;
  const year = new Date().getFullYear();

  return (
    <div className={styles.root} data-brand={brand.dataBrand}>
      <aside className={styles.brandPanel} aria-label={brand.legalName}>
        <div className={styles.brandAmbient} aria-hidden>
          <div className={styles.brandBase} />
          <div className={styles.brandPattern} />
          <div className={`${styles.orb} ${styles.orbMenthol}`} />
          <div className={`${styles.orb} ${styles.orbTeal}`} />
          <div className={`${styles.orb} ${styles.orbMint}`} />
          <div className={`${styles.orb} ${styles.orbDeep}`} />
          <div className={styles.brandSheen} />
          <div className={styles.brandGrain} />
        </div>

        <div className={styles.brandContent}>
          <span className={styles.brandLogo} role="img" aria-label={brand.legalName} />
          <div className={styles.brandCopy}>
            <p className={styles.brandTitle}>{title}</p>
            <p className={styles.brandBody}>{brandBody}</p>
          </div>
        </div>

        <p className={styles.brandCopyright}>© {year} {brand.legalName}</p>
      </aside>

      <div className={cx(styles.formColumn, SURFACE_GRAIN.overlay)}>
        <div className={styles.formWrap}>
          <div className={styles.mobileBrand}>
            <span className={styles.mobileBrandLogo} role="img" aria-label={brand.legalName} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
